import React from 'react';
import { useSelector } from 'react-redux';
import { Link, useRouteMatch } from 'react-router-dom';
import { WysiwygWithReactLink } from '../../../global/components/wysiwyg-with-react-link';
import { getCurrencyFormat, getYearsFormat } from '../../../global/helpers/format-helpers';
import { YesNoIndicators } from '../../../global/models/api-model';
import { LabelSettingProps } from '../../../global/models/epi-model';
import { TcsmStates } from '../../../root/tcsm-model';
import { DbData, MyCpgPodsSettings, MyCpgPodsTypes, PodContent } from '../mycpg-pod-models';
import { PodGridContent } from './pod-grid-content';
import { PodGridContentItem } from './pod-grid-content-item';
import { PodGridItem } from './pod-grid-item';
import { PodGridItemHeader } from './pod-grid-item-header';


interface Props {
	settings: MyCpgPodsSettings;
}
export function PensionPlanPod(props: Props) {

	const labelSettings = useSelector<TcsmStates, LabelSettingProps>(a => a.epiProps?.labelSettingState?.epiContent);
	const { settings } = props;
	const dbPlan = useSelector<TcsmStates, DbData>(state => state?.mycpgPodsState?.pods?.db_data);
	const hidePod = dbPlan?.show_pod === YesNoIndicators.No;
	const noPlan = dbPlan?.content === PodContent.NOT_ENROLLED;
	const routeMatch = useRouteMatch();


	if (hidePod) {
		return null;
	}



	const renderDB = () => {

		if (dbPlan?.data.length > 0) {

			const multipleDb = dbPlan?.data?.length > 1;
			const firstDb = dbPlan?.data[0];

			return (
				<>
					{
						multipleDb &&
						<PodGridContentItem>
							<p className='grey-caption'>{settings?.seeMoreHelperText}</p>

						</PodGridContentItem>
					}
					<PodGridContentItem>
						<p>{firstDb?.plan_title}</p>
					</PodGridContentItem>
					{
						!firstDb?.highest_average_compensation ?
							<>
								{
									(firstDb?.retirement_date || firstDb?.benefits_effective_date) &&
									<PodGridContentItem>
										<p className='h3-styled'>{firstDb?.retirement_date ? firstDb?.retirement_date : firstDb?.benefits_effective_date}</p>
										<p className='grey-caption'>{firstDb?.retirement_date ? settings?.retirementDateLabel : settings?.benefitEffectiveDateLabel}</p>
									</PodGridContentItem>
								}
								<PodGridContentItem>
									<p className='h3-styled'>{getCurrencyFormat(firstDb?.monthly_pension)}</p>
									<p className='grey-caption'>{settings?.monthlyPensionBenefitLabel}</p>
								</PodGridContentItem>
							</> :
							<>
								<PodGridContentItem>
									<p className='h3-styled'>{`${getYearsFormat(firstDb?.years_of_credited_service)} ${labelSettings?.yearsText ? labelSettings?.yearsText : 'years' }`}</p>
									<p className='grey-caption'>{settings?.creditedServiceLabel}</p>
								</PodGridContentItem>
								<PodGridContentItem>
									<p className='h3-styled'>{getCurrencyFormat(firstDb?.highest_average_compensation)}</p>
									<p className='grey-caption'>{settings?.highestAvgCompensationLabel}</p>
								</PodGridContentItem>
							</>
					}
				</>
			);
		}

		return null;
	};


	const renderContent = () => {

		if (noPlan) {
			return (
				<PodGridContentItem>
					<div dangerouslySetInnerHTML={{ __html: settings?.noPensionPlanText }} />
				</PodGridContentItem>
			);
		}


		if (dbPlan?.content === PodContent.CONTENT) {
			return renderDB();
		}

		return null;
	};

	const totalCount = dbPlan?.data?.length;

	return (
		<PodGridItem>
			<PodGridItemHeader title={`${settings?.pensionPlanPodTitle} (${totalCount})`}>

				<Link to={`${routeMatch?.path}?type=${MyCpgPodsTypes.PENSION}`}>{noPlan ? settings?.learnMoreText : settings?.seeMoreLinkText}</Link>

			</PodGridItemHeader>
			<PodGridContent>
				{renderContent()}
				<WysiwygWithReactLink content={settings.pensionPlanPodFooterContent} />
			</PodGridContent>
		</PodGridItem>
	);

}

